import { observer } from "mobx-react-lite";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { DateTime } from "luxon";
import * as React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { useHistory } from "react-router-dom";
import Edit from "@material-ui/icons/Edit";
import { UserRoleRuEnum, UserRoleEnum } from "../../../../static/enums/UserRole";
import { User } from "../../../../api/typings/Users";
import { Profiles, ContentMakerProfile } from "../../../../api/typings/Profiles";
import { tableStore } from "../../../../mobx/stores/TableStore/TableStore";
import { Routes } from "../../../../routes/routes";

function contentMakersFilter(profile: Profiles): profile is ContentMakerProfile {
  return profile.role === UserRoleEnum.contenter;
}

interface ContentMakersProfilesTableRowProps {
  user: User;
}

export const ContentMakersProfilesTableRow = observer(({ user }: ContentMakersProfilesTableRowProps) => {
  const { usersProfiles } = tableStore;
  const profilesContentMakers = (Object.values(usersProfiles) as Profiles[]).filter(contentMakersFilter);
  const profilesId = user.profiles.map((profile) => profile.id);
  const profileInfo = profilesContentMakers.find((profile) => profilesId.some((id) => profile.id === id));
  if (!profileInfo) return null;
  const history = useHistory();

  return (
    <>
      <TableRow hover>
        <TableCell>{user.id}</TableCell>
        <TableCell>
          {user.firstname} {user.lastname}
        </TableCell>
        <TableCell>{UserRoleRuEnum[profileInfo.role]}</TableCell>
        <TableCell>{DateTime.fromISO(profileInfo.created_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
        <TableCell>{DateTime.fromISO(profileInfo.updated_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
        <TableCell>
          <Tooltip title={<Typography variant={"caption"}>Редактировать</Typography>}>
            <IconButton onClick={() => handleUserInfo(user.id)}>
              <Edit color={"secondary"} fontSize={"small"} />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  );

  function handleUserInfo(id: string): void {
    history.push(`/${Routes.user}/${id}`);
  }
});
